<label [class]="'body p-4 ' + variant()" [for]="name() + '_' + index()">
  <input
    [tabIndex]="tabbable() ? 0 : -1"
    type="radio"
    tabindex="0"
    [value]="optionValue()"
    [attr.name]="name()"
    [name]="name()"
    [id]="name() + '_' + index()"
    [ngModel]="value"
    [disabled]="disabled"
    [checked]="value === optionValue()"
    [ngModelOptions]="{ standalone: true }"
    (ngModelChange)="writeValue($event)"
    (click)="selectOption(value)"
  />
  <div class="radio mr-8"></div>

  <ng-content></ng-content>

  @if (includeResetOption() && value === optionValue()) {
  <button class="reset" (click)="resetClicked.emit()">
    <i class="fa-light fa-arrow-rotate-left"></i>
  </button>
  }
</label>
